// App runtime config
export const Loading = "loading";
export const NOTIFICATION_TIMEOUT = 1000;
/** HTTP request timeout per call. Matches mobile SERVER_RESPONSE_TIMEOUT_IN_MS. */
export const API_REQUEST_TIMEOUT_MS = 5 * 60 * 1000; // 5 minutes
export const ID_SEPARATOR = ":";

// ── React Query cache lifetimes ───────────────────────────────────────────────

/** How long cached data is considered fresh before a background refetch is triggered. */
export const QUERY_STALE_TIME_MS = 5 * 60 * 1000; // 5 minutes

/** How long inactive (unsubscribed) cache entries remain in memory before garbage collection. */
export const QUERY_GC_TIME_MS = 5 * 60 * 1000; // 5 minutes

/** Maximum number of retries for transient errors (network, 408, 429, 5xx). */
export const QUERY_MAX_RETRIES = 3;

/**
 * Extended gcTime for high-value cache entries that benefit from a longer
 * in-memory lifetime (e.g. user profile — avoids a refetch when the user
 * navigates away and returns within a normal session).
 */
export const QUERY_GC_TIME_LONG_MS = 60 * 60 * 1000; // 60 minutes
export const EMPTY_GUID = "00000000-0000-0000-0000-000000000000";

// Pagination
export const DEFAULT_PAGE_SIZE = 50;
export const SUBROW_PAGINATION_DEFAULT_PAGE_SIZE = 25;
export const DEFAULT_PAGE_INDEX = 1;
export const M_CROPS_FETCH_PAGE_SIZE = 100;
export const STEP_CATALOGUE_GC_PAGE_SIZE = 100;

// Debounce
export const INPUT_DOCUMENT_SAVE_DEBOUNCE_MS = 3000;

/** How long a copy waits for the open plan to save; nothing is copied before then, so it can just be tried again. */
export const COPY_TOOL_OPEN_PLAN_SAVE_TIMEOUT_MS = 60 * 1000; // 1 minute
/** How many destinations the copy tool saves at once. */
export const COPY_TOOL_CONCURRENCY = 4;
/** How long the tree's copied ticks and the copy's success toast stay. */
export const COPY_TOOL_COPIED_FEEDBACK_MS = 5 * 1000; // 5 seconds
/** Above antd's dropdowns and tooltips (1050+), so nothing in Planning can be picked while a copy writes it. */
export const COPY_TOOL_HOLD_Z_INDEX = 2000;
/** react-toastify's container; the copy hold leaves its keys and focus alone. */
export const TOAST_CONTAINER_SELECTOR = ".Toastify";
/** antd's modal content, such as the copy tool. */
export const ANTD_MODAL_SELECTOR = ".ant-modal";

// Feature switches
/**
 * Add product and Delete in the Nutrition lens (OP-2523): built, but hidden
 * until they've been through UAT. Rate editing and undo are unaffected.
 */
export const NUTRITION_ADD_REMOVE_PRODUCTS_ENABLED = false;

// Name given to the personal M organisation web creates on demand (matches
// mobile) when a user has none yet.
export const DEFAULT_M_ORGANISATION_NAME = "Default master data";

// How long the Update defaults note stays beside its row.
export const UPDATE_DEFAULTS_NOTE_MS = 5000;
